import { render } from "./ButtonHero.vue?vue&type=template&id=821dd6a0&scoped=true"
import script from "./ButtonHero.vue?vue&type=script&lang=js"
export * from "./ButtonHero.vue?vue&type=script&lang=js"

import "./ButtonHero.vue?vue&type=style&index=0&id=821dd6a0&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821dd6a0"]])

export default __exports__